const scripts = `
try {
  // Expected to be in the following form:
  // {
    // 'module-name': {
      // product_names_sorted: just product names sorted
      // product_ids_map: product id mapped to name, id, model, sku
      // related_products_map - primary product mapped to related product mapped to limit, rules, dimension,impact
        // {
        //   92: {
        //     98: {
        //       impactDimensions: true,
        //       limit: 2,
        //       rulesObj: {
        //         meetAll: true,
        //         rules: []
        //       }
        //     }
        //   }
        // },
      // logic_map: field name mapped to object consisting of key and pids
        //module-...dropdown-0:{key:"printer-model", pids: [92, 94]},
        //module-...opts-checkbox-0:{key:"additional-options", pids: [98]}
      // dropdown_options_map: dropdown field name mapped to product id mapped to array of options
        //module...dropdown-1:{94:[optionId,label]}
      // product_option_id_map: product id mapped to key
        //92: "printer-model"
      // key_filter_map: map of element type to the keys its related to
        //dropdowns: ["printer-model","cabinet-stand-option"],
        //checkboxes: ["additional-options"]
      // settings,
    // }
  // }
  var cfgTool_vars = {{script_vars}};

  //configState={module_name:{printer-model:92}}
  var configState = {};
  // Previous variakbles by module name
  // e.g. { 'module-1_dropdown-1' : '2-4 Hole Punch Kit', ... }
  var cfgTool_prev_vars = {};
  //main filer of dropdown that determines primary product
  var PRIMARY_FILTER = "printer-model";
  var CABINET_FILTER = "cabinet-stand-option";
  var OPTIONS_FILTER = "additional-options";
  var STAPLER_ID = 102;
  var CARTRIDGE_ID = 103;

  function cfgTool_enumerateFieldsByPrefix(prefix) {
    var fields = [];
    var idx = 0;
    var found;
    do {
      // Build name: <pfx><idx>
      var field_name = prefix + idx;
      var field = getField(field_name);
      found = !!field;
      if (found) {
        fields.push(field);
      }
      ++idx;
    } while (found);
    return fields;
  }

  function cfgTool_initCheckboxListener(module_name_pfx, field_name) {
    var field = getField(field_name);
    if (!field) return false;
    field.style = style.ch;
    field.readonly = true;
    field.setAction(
      "MouseUp",
      "cfgTool_fieldChanged('" + module_name_pfx + "', '" + field_name + "')"
    );

    // Cache current value
    cfgTool_prev_vars[field_name] = field.value;

    return true;
  }

  // Checkboxes are named as follows:
  // <module_name_pfx>_checkboxes-<cbox_idx>
  function cfgTool_initCheckboxListeners(module_name_pfx) {
    const checkboxes = cfgTool_enumerateCheckboxes(module_name_pfx);
    checkboxes.forEach((f) => {
      cfgTool_initCheckboxListener(module_name_pfx, f.name);
    });
  }

  function cfgTool_initDropdownListener(module_name_pfx, field_name) {
    var field = getField(field_name);
    if (field_name === module_name_pfx + "_content_dropdown-0") {
      //init first dropdown with product ids as value instead of name
      const { logic_map, product_ids_map } =
        cfgTool_vars[module_name_pfx];
      const dropdownOptions = logic_map[field_name].pids;
      const defaultOption = field.getItemAt(0);
      field.setItems([defaultOption]);
      for (var i = 0; i < dropdownOptions.length; i++) {
        field.insertItemAt(
          product_ids_map[dropdownOptions[i]].name,
          dropdownOptions[i],
          i + 1
        );
      }
      field.deleteItemAt(0);
      //making this the most recent insertion makes it selected
      field.insertItemAt(defaultOption, 0, 0);
    }
    if (field_name !== module_name_pfx + "_content_dropdown-0") {
      field.readonly = true;
    }
    if (field_name === module_name_pfx + "_content_dropdown-1") {
      field.setItems([field.getItemAt(0)]);
    }
    if (!field) return false;
    field.commitOnSelChange = true;
    field.setAction(
      "Calculate",
      "cfgTool_fieldChanged('" + module_name_pfx + "', '" + field_name + "')"
    );

    // Cache current value
    cfgTool_prev_vars[field_name] = field.value;

    return true;
  }

  function cfgTool_enumerateDropdowns(module_name_pfx) {
    return cfgTool_enumerateFieldsByPrefix(
      module_name_pfx + "_content_dropdown-"
    );
  }

  function cfgTool_enumerateOptionDropdowns(module_name_pfx) {
    return cfgTool_enumerateFieldsByPrefix(
      module_name_pfx + "_content_opts_select-"
    );
  }

  function cfgTool_enumerateCheckboxes(module_name_pfx) {
    return cfgTool_enumerateFieldsByPrefix(
      module_name_pfx + "_content_opts_checkbox-"
    );
  }

  // Dropdowns are named as follows:
  // <module_name_pfx>_dropdown-<dropdown_idx>
  function cfgTool_initDropdownListeners(module_name_pfx) {
    const dropdown_fields = cfgTool_enumerateDropdowns(module_name_pfx);
    const option_dropdown_fields =
      cfgTool_enumerateOptionDropdowns(module_name_pfx);
    const allDropdowns = [...dropdown_fields, ...option_dropdown_fields];
    allDropdowns.forEach((f) => {
      cfgTool_initDropdownListener(module_name_pfx, f.name);
    });
  }

  function cfgTool_getSortedSelectedProducts(module_name_pfx) {
    //gets the ids of products in config and then get the actual products
    const { product_ids_map } = cfgTool_vars[module_name_pfx];
    const configKeys = getConfigProductIds(configState[module_name_pfx], false);
    const selected_products = [];
    for (var i = 0; i < configKeys.length; i++) {
      selected_products.push(product_ids_map[configKeys[i]]);
    }
    return selected_products;
  }

  //get all IDs within a config
  function getConfigProductIds(obj, useK) {
    var arr = [];
    const keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
      const k = keys[i];
      const v = obj[k];
      if (typeof v === "object") {
        arr = arr.concat(getConfigProductIds(v, true));
      } else {
        if (useK) {
          arr.push(Number(k));
        } else {
          arr.push(Number(v));
        }
      }
    }
    return arr;
  }

  // Update overline, title and part numbers
  function cfgTool_updateFieldValues(module_name_pfx) {
    const { product_ids_map } = cfgTool_vars[module_name_pfx];
    // Skip overline since it is hardcoded to read "WorkForce Enterprise"
    var primary_dropdown = getField(module_name_pfx + "_content_dropdown-0");
    var primary_product = product_ids_map[primary_dropdown.value];
    if (primary_product) {
      const { logic_map } = cfgTool_vars[module_name_pfx];
      const first_key = Object.keys(logic_map)[0];
      const products = logic_map[first_key].pids;
      products.forEach((id) => {
        const show_layer = id === primary_product.id;
        toggleLayer(module_name_pfx + "_content_title-" + id, show_layer);
      });
    }

    // Keep track of row index to update
    const sorted_selected_products =
      cfgTool_getSortedSelectedProducts(module_name_pfx);
    var row_idx = sorted_selected_products.length;

    cfgTool_showTableValues(module_name_pfx);

    const max_products = cfgTool_getMaxProducts();

    // Hide remaining rows
    for (row_idx; row_idx < max_products; ++row_idx) {
      cfgTool_toggleRow(module_name_pfx, row_idx, false);
    }
  }

  // Set table values by showing dropdown values
  // followed by checkbox ones, both in order.
  function cfgTool_showTableValues(module_name_pfx) {
    const sorted_selected_products =
      cfgTool_getSortedSelectedProducts(module_name_pfx);
    cfgTool_toggleTableValues(module_name_pfx, sorted_selected_products, true);
  }
  const multiline_threshold = 25;
  function cfgTool_setCellValue(field_name, value, is_bold) {
    var field = getField(field_name);
    const value_str = value || "";
    field.multiline = value_str.length > multiline_threshold;
    field.richText = true;

    field.richValue = [
      {
        fontWeight: is_bold ? 900 : 400,
        fontFamily: ["Helvetica"],
        text: value,
      },
    ];
  }
  function cfgTool_setRowValues(module_name_pfx, row_idx, v_th, v_td) {
    const th_name = module_name_pfx + "_content_th-" + row_idx;
    // setFieldValue(th_name, v_th);
    cfgTool_setCellValue(th_name, v_th, true);
    const td_name = module_name_pfx + "_content_td-" + row_idx;
    // setFieldValue(td_name, v_td);
    cfgTool_setCellValue(td_name, v_td);
  }

  // Also remove field values so that when the field is shown it is empty.
  // Otherwise, on slower systems we may sometimes briefly see the field with old content.
  function cfgTool_hideTableValues(module_name_pfx) {
    const sorted_selected_products =
      cfgTool_getSortedSelectedProducts(module_name_pfx);
    const empty_values = makeEmptyArray(sorted_selected_products.length + 1, {});
    cfgTool_toggleTableValues(module_name_pfx, empty_values, false);
  }
  // Toggle visibility
  function cfgTool_toggleTableValues(module_name_pfx, table_values_list, state) {
    table_values_list.forEach((obj, row_idx) => {
      const { model, sku } = obj || {};
      const v_th = (state && model) || "";
      const v_td = (state && sku) || "";
      cfgTool_setRowValues(module_name_pfx, row_idx, v_th, v_td);
      cfgTool_toggleRow(module_name_pfx, row_idx, state);
    });
  }

  function cfgTool_toggleRow(module_name_pfx, row_idx, state) {
    // Hide table BG & border
    toggleLayer(module_name_pfx + "_content_row-" + row_idx, state);
    // Hide header field
    toggleFieldVisibility(module_name_pfx + "_content_th-" + row_idx, state);
    // Hide value field
    toggleFieldVisibility(module_name_pfx + "_content_td-" + row_idx, state);
  }

  // Enable/disable image layers for this module as appropriate.
  function cfgTool_showImageFromLogic(module_name_pfx) {
    if (!cfgTool_vars[module_name_pfx]) return -1;

    const { settings } = cfgTool_vars[module_name_pfx];
    const match_idx = cfgTool_getImageIndexToShow(module_name_pfx);
    const max_images = settings.length;
    for (var i = 0; i < max_images; ++i) {
      const show_layer = i === match_idx;
      const image_layer_name = module_name_pfx + "_content_image-" + i;
      toggleLayer(image_layer_name, show_layer);
    }
  }

  // Find the setting that matches current config and return the index
  function cfgTool_getImageIndexToShow(module_name_pfx) {
    if (!cfgTool_vars[module_name_pfx]) return -1;

    const { settings } = cfgTool_vars[module_name_pfx];
    const filteredByDimensionConfig = filterByDimensionImpact(
      module_name_pfx,
      configState[module_name_pfx]
    );

    for (var i = 0; i < settings.length; i++) {
      const f = settings[i].formula;
      if (sameSettings(filteredByDimensionConfig, f)) {
        return i;
      }
    }
    return -1;
  }

  //removes keys with value of 0
  function filterConfig(obj) {
    const keys = Object.keys(obj);
    const newObj = {};
    for (var i = 0; i < keys.length; i++) {
      const k = Object.keys(obj)[i];
      const v = obj[k];
      if (typeof v === "object") {
        const cleanV = filterConfig(v);
        if (Object.keys(cleanV).length > 0) {
          newObj[k] = filterConfig(v);
        }
      } else {
        if (v) {
          newObj[k] = v;
        }
      }
    }
    return newObj;
  }

  //filters out the additional options that do not impact dimensions
  function filterByDimensionImpact(module_name_pfx, builtConfig) {
    const { related_products_map } = cfgTool_vars[module_name_pfx];
    const primaryId = builtConfig[PRIMARY_FILTER];
    if (!primaryId) return builtConfig;
    const obj = {};
    const keys = Object.keys(builtConfig);
    for (var i = 0; i < keys.length; i++) {
      const k = keys[i];
      const v = builtConfig[k];
      if (typeof v === "object") {
        const o = {};
        const vkeys = Object.keys(v);
        for (var j = 0; j < vkeys.length; j++) {
          const vk = vkeys[j];
          const vv = v[vk];
          if (related_products_map[primaryId] && related_products_map[primaryId][vk] &&
            related_products_map[primaryId][vk].impactDimensions) {
            o[vk] = vv;
          }
        }
        obj[k] = o;
      } else obj[k] = v;
    }
    return filterConfig(obj);
  }

  //returns whether two objects are the same
  function sameSettings(a, b) {
    if (!a || !b) return false;
    const aKeys = new Set(Object.keys(a));
    const bKeys = Object.keys(b);
    if (aKeys.size !== bKeys.length) return false;
    for (var i = 0; i < bKeys.length; i++) {
      const bk = bKeys[i];
      if (!aKeys.has(bk)) {
        return false;
      }
    }
    for (var j = 0; j < bKeys.length; j++) {
      const k = bKeys[j];
      if (typeof a[k] === "object") {
        //check additional options
        if (!sameSettings(a[k], b[k])) return false;
      } else if (a[k] != b[k]) return false;
    }
    return true;
  }

  function cfgTool_getMaxProducts() {
    // Table values range as follows:
    //   0-7 WF-Enterprise
    //   0-8 Latin WF-Enterprise
    // TODO: acquire this number more appropriately
    return 10;
  }

  const title_field_names = ["_overline", "_title", "_email-btn"];
  // These are **parts** of the name. For example, <module>_th-<idx>
  const table_field_names = ["_th-", "_td-"];
  function cfgTool_toggleConfigSection(module_name_pfx, state) {
    const pfx = module_name_pfx + "_content";
    toggleLayer(pfx, state);

    // Export button visibility
    const export_visibility_lyr_name =
      module_name_pfx + "_helper_export-btn-visibility";
    toggleLayer(export_visibility_lyr_name, !state);

    // Toggle fields
    title_field_names.forEach((n) => {
      const field_name = pfx + n;
      toggleFieldVisibility(field_name, state);
    });

    // Hide table cells
    if (!state) {
      cfgTool_hideTableValues(module_name_pfx);
    }
  }

  function cfgTool_hideConfigSection(module_name_pfx) {
    cfgTool_toggleConfigSection(module_name_pfx, false);
  }

  function cfgTool_showConfigSection(module_name_pfx, id) {
    cfgTool_toggleConfigSection(module_name_pfx, true);
  }

  function cfgTool_fieldIsUsedInLogic(module_name_pfx, name) {
    if (!cfgTool_vars[module_name_pfx]) {
      console.println(
        'ERROR: Module config for "' + module_name_pfx + '" not found'
      );
      return null;
    }
    return cfgTool_vars[module_name_pfx].logic_field_names[name];
  }

  // New line character. We do this because
  // scripts get processed prior to adding to the PDF,
  // and newlines are removed at that stage.
  const nl = String.fromCharCode(10);
  function cfgTool_emailConfig(module_name_pfx) {
    const export_url = cfgTool_getExportUrl(module_name_pfx);
    if (export_url == "") return;

    // Collect selected product names & skus
    const sorted_selected_products =
      cfgTool_getSortedSelectedProducts(module_name_pfx);
    const products_msg = sorted_selected_products
      .map(({ model, sku }, idx) => {
        if (idx === 0) {
          return model + " (" + sku + ")";
        } else {
          return " + " + model + " (" + sku + ")";
        }
      })
      .join(nl);

    // const header_msg = 'WorkForce Enterprise Series' + nl + nl;
    //const link_msg = nl + nl + export_url;
    // const msg = header_msg + products_msg;
    const msg = products_msg;

    app.mailMsg({
      bUI: true,
      cTo: "",
      cSubject: "Epson WorkForce Enterprise Configuration",
      cMsg: msg,
    });
  }

  function cfgTool_fieldChanged(module_name_pfx, field_name) {
    var field = getField(field_name);
    // Skip processing if current value matches previous one
    if (field.value == cfgTool_prev_vars[field_name]) {
      return;
    }
  
    cfgTool_prev_vars[field_name] = field.value;

    var fromStapler = false;
  
    const { logic_map, key_filter_map, related_products_map } =
      cfgTool_vars[module_name_pfx];
    const keyPidObj = logic_map[field_name];
    const { key, pids } = keyPidObj;
    var valueToAdd = 0;
    //add the value to the config based on field type
    if (key_filter_map.dropdowns.indexOf(key) !== -1) {
      valueToAdd = field.value;
      if (key === PRIMARY_FILTER) {
        configState[module_name_pfx] = {};
      }
      configState[module_name_pfx][key] = valueToAdd;
    }
    const primaryId = configState[module_name_pfx][PRIMARY_FILTER];
    if (key_filter_map.checkboxes.indexOf(key) !== -1) {
      const relatedProducts = Object.keys(related_products_map[primaryId] || {});
      const pid = findRelatedPid(pids, relatedProducts);
      if (pid == STAPLER_ID) fromStapler = true;
      //if checkbox
      if (field.value === "On") {
        valueToAdd = 1;
      } else if (field.value === "Off") {
        valueToAdd = 0;
      } else {
        //if select
        valueToAdd = Number(field.value);
      }
      if (configState[module_name_pfx][key]) {
        configState[module_name_pfx][key][pid] = valueToAdd;
      } else {
        configState[module_name_pfx][key] = {};
        configState[module_name_pfx][key][pid] = valueToAdd;
      }
    }
    configState[module_name_pfx] = filterConfig(
      removeRuleBreakers(
        module_name_pfx,
        configState[module_name_pfx][PRIMARY_FILTER],
        configState[module_name_pfx],
        null,
        false
      )
    );
    //if primary changed then reset second dropdown
    if (field_name === module_name_pfx + "_content_dropdown-0") {
      resetSecondDropdown(module_name_pfx, field.value);
      resetAdditionalOptions(module_name_pfx);
    }
    const fromDropdown = key_filter_map.dropdowns.indexOf(key) !== -1;
    updateAdditionalOptions(module_name_pfx, fromDropdown,fromStapler, field_name);
    cfgTool_reprocessLogic(module_name_pfx);
  }  

  function resetSecondDropdown(module_name_pfx, primaryId) {
    //add only options related to primary product and then make default be selected
    const { dropdown_options_map } = cfgTool_vars[module_name_pfx];
    const fieldName = module_name_pfx + "_content_dropdown-1";
    const optionsMap = dropdown_options_map[fieldName];
    const options = optionsMap[primaryId];
    const field = getField(fieldName);
    const defaultOptionValue = field.getItemAt(0);
    const defaultOptionLabel = field.getItemAt(0, false);
    field.setItems([defaultOptionValue]);
    if (options) {
      for (var i = 0; i < options.length; i++) {
        field.insertItemAt(options[i][1], options[i][0], i + 1);
      }
    }
    field.deleteItemAt(0);
    field.insertItemAt(defaultOptionLabel, 0, 0);
    if (primaryId > 0) {
      field.readonly = false;
    }
    else {
      field.readonly = true;
    }
  }

  function resetAdditionalOptions(module_name_pfx) {
    //add only options related to primary product and then make default be selected
    const { logic_map } = cfgTool_vars[module_name_pfx];
    const keys = Object.keys(logic_map);
    for (var i = 0; i < keys.length; i++) {
      const fieldName = keys[i];
      if (logic_map[fieldName].key === OPTIONS_FILTER) {
        resetForm([fieldName]);
        const field = getField(fieldName);
        if(field.type !== "checkbox") field.value = field.getItemAt(0);
      }
    }
  }

  function shouldUpdateOptions(field, newOptions){
    if (newOptions.length !== field.numItems) return true;
    if (newOptions.length === field.numItems){
      return newOptions.slice(1).some((newOp,idx)=>{
        return newOp[0] != field.getItemAt(idx+1,false) || 
        newOp[1] != field.getItemAt(idx+1)
      });
    }
  }

  function updateAdditionalOptions(module_name_pfx, fromDropdown, fromStapler,  updatedFieldName) {
    const {
      logic_map,
      product_ids_map,
      related_products_map,
      dropdown_options_map,
      opt_products_reverse
    } = cfgTool_vars[module_name_pfx];

    var primaryId = configState[module_name_pfx][PRIMARY_FILTER];
    if (!primaryId) primaryId = 0;
    const optionKeys = Object.keys(logic_map);
    for (var i = 0; i < optionKeys.length; i++) {
      const fieldName = optionKeys[i];
      if (fromStapler && fieldName !== opt_products_reverse[CARTRIDGE_ID]) continue;
      //remove invalid cabinet options
      if (logic_map[fieldName].key === CABINET_FILTER 
        && updatedFieldName !== module_name_pfx + "_content_dropdown-1" ) {
        if (primaryId === 0) continue;
        const field_drop = getField(fieldName);
        const defaultDropLabel = field_drop.getItemAt(0,false);
        const defaultDropVal = field_drop.getItemAt(0);
        const newOptions = [[defaultDropLabel, defaultDropVal]];
        const allOptions = dropdown_options_map[fieldName][primaryId];
        const builtConfigDrop = configState[module_name_pfx];
        //find current value in list of al values
        //if it's still valid, make it the current value again after setting the new options
        var curValIdx = 0;
        allOptions.forEach((option,idx) => {
          const optVal = option[0];
          if (field_drop.value == optVal) curValIdx = idx+1;
          const satisfiesRules = hypotheticalConfigSatisfiesRules(
            module_name_pfx,
            primaryId,
            builtConfigDrop,
            dataFilter,
            option[0]
          );
          if (satisfiesRules) newOptions.push([option[1], option[0]]);
        });
        if (shouldUpdateOptions(field_drop, newOptions)){
          field_drop.setItems(newOptions);
          if (curValIdx > 0) {
            field_drop.value = allOptions[curValIdx-1][0];
          }
          else {
            field_drop.deleteItemAt(0);
            field_drop.insertItemAt(defaultDropLabel, defaultDropVal, 0);
          }
        }
      }
      if ((fromDropdown || fromStapler) && logic_map[fieldName].key === OPTIONS_FILTER && updatedFieldName != fieldName) {
        const relatedProducts = Object.keys(related_products_map[primaryId] || {});
        const pids = logic_map[fieldName].pids;
        const pid = findRelatedPid(pids, relatedProducts);
        const field = getField(fieldName);
        if (primaryId > 0 && relatedProducts.indexOf(pid) !== -1) {
          const builtConfig = configState[module_name_pfx];
          const relatedProps = related_products_map[primaryId][pid];
          const dataFilter = logic_map[fieldName].key;
          var passesRulesLimit = relatedProps.limit + 1;
          if (passesRulesLimit === 1) { // if original limit was 0
            passesRulesLimit = 100;
          }
          const passesRules = [];
          for (var j = 0; j < passesRulesLimit; j++) {
            passesRules.push(
              hypotheticalConfigSatisfiesRules(
                module_name_pfx,
                primaryId,
                builtConfig,
                dataFilter,
                j,
                pid
              )
            );
          }
          if (passesRules.indexOf(true) !== -1) {
            //keep track of current value and make it current again after setting new options
            field.readonly = false;
            if (field.type !== "checkbox") {
              const options = [];
              const curVal = field.value; 
              for (var k = 0; k < passesRulesLimit; k++) {
                if (passesRules[k]) {
                  if (k===0) options.push(["-",0]);
                  else options.push([k, k]);
                }
              }
              const primaryChanged = updatedFieldName === module_name_pfx + "_content_dropdown-0";
              if(shouldUpdateOptions(field, options)){
                field.setItems(options);
                if (passesRules[curVal] && curVal > 0 && !primaryChanged) {
                  field.deleteItemAt(curVal);
                  field.insertItemAt(curVal, curVal, curVal);
                  field.value = curVal;
                }
                else {
                    field.deleteItemAt(0);
                    field.insertItemAt("-",0,0);
                    if (field.numItems === 1) field.readonly = true;
                }
              }
            }
          } 
          else if (fromDropdown) {
            if(field.type!=="checkbox"){
              field.deleteItemAt(0);
              field.insertItemAt("-",0,0);
            }
            field.readonly = true;
            resetForm([fieldName]);
          }
          else if (fromStapler){
            if (fieldName == opt_products_reverse[CARTRIDGE_ID]){
              field.value = field.getItemAt(0);
              field.readonly = true;
              resetForm([fieldName]);
            }
          }
        }
        else if (logic_map[fieldName].key === OPTIONS_FILTER) {
          if(field.type!=="checkbox"){
            field.deleteItemAt(0);
            field.insertItemAt("-",0,0);
          }
          field.readonly = true;
          resetForm([fieldName]);
        }
      }
    }
  }  

  function findRelatedPid(pids, relatedProducts) {
    for (var i = 0; i < pids.length; i++) {
      if (relatedProducts.indexOf(pids[i]) !== -1) {
        return pids[i];
      }
    }
    return pids[0];
  }

  function cfgTool_isPrimaryModelSelected(module_name_pfx) {
    if (
      !configState[module_name_pfx] ||
      !configState[module_name_pfx][PRIMARY_FILTER]
    ) {
      return false;
    }
    var primaryId = configState[module_name_pfx][PRIMARY_FILTER];
    return primaryId > 0;
  }

  // Review provided logic, toggling layers and fields as necessary
  function cfgTool_reprocessLogic(module_name_pfx) {
    // Hide "Selected Model" information until a "Printer Model" is Selected

    const is_primary_selected = cfgTool_isPrimaryModelSelected(module_name_pfx);
    if (!is_primary_selected) {
      cfgTool_updateFieldValues(module_name_pfx);
      cfgTool_hideConfigSection(module_name_pfx);
      return;
    }

    // Show config section and selected options
    cfgTool_showConfigSection(module_name_pfx);
    cfgTool_showImageFromLogic(module_name_pfx);
    cfgTool_updateFieldValues(module_name_pfx);
  }

  function cfgTool_getExportUrl(module_name_pfx) {
    // Require primary product to be selected
    const is_primary_selected = cfgTool_isPrimaryModelSelected(module_name_pfx);
    if (!is_primary_selected) return "";

    const { api_url, project, s3_key } = globals;
    const base_target_url = api_url + "/spe/" + project + "/" + s3_key + "/k?";
    const query_string = configToQueryParams(module_name_pfx);
    const export_url = base_target_url + "cache_key=" + escape(query_string);
    return export_url;
  }

  function cfgTool_export(module_name_pfx) {
    const export_url = cfgTool_getExportUrl(module_name_pfx);
    if (export_url !== "") app.launchURL(export_url);
  }

  //rules functions taken from ModularFunctions.js
  function passRule(module_name_pfx, rule, config) {
    const { product_option_id_map } = cfgTool_vars[module_name_pfx];
    const { operator, product, value_1: v1, value_2: v2 } = rule;
    if (!product) return true;
    const pid = product.id;
    var pval = config[product_option_id_map[pid]] || 0;
    if (pval) pval = pval[pid] || 0;
    switch (operator) {
      case "between":
        return v1 <= pval && pval <= v2;
      case "equals":
        return pval == v1;
      case "not_equals":
        return pval !== v1;
    }
  }

  function passRules(module_name_pfx, rulesObj, config) {
    if (!rulesObj) return true;
    const { rules, meetAll } = rulesObj;
    if (!rules || rules.length === 0) return true;
    const evaluatedRules = new Set(
      rules.map((r) => passRule(module_name_pfx, r, config))
    );
    if (meetAll === true)
      return evaluatedRules.has(true) && evaluatedRules.size === 1;
    return evaluatedRules.has(true);
  }

  //takes a config and sees if all the rules are satisfied within it
  function allRulesSatisfied(primaryId, config, module_name_pfx) {
    if (!primaryId || !config) return false;
    const { related_products_map } = cfgTool_vars[module_name_pfx];
    const configKeys = getConfigProductIds(config, false);
    for (var i = 0; i < configKeys.length; i++) {
      const k = configKeys[i];
      var rulesObj = related_products_map[primaryId][k.toString()];
      if (rulesObj) rulesObj = rulesObj.rulesObj;
      const passedRule = passRules(module_name_pfx, rulesObj, config);
      if (!passedRule) return false;
    }
    return true;
  }

  //get the ids of products whose inclusion is allowed
  function getCompliers(primaryId, config, module_name_pfx) {
    const { related_products_map } = cfgTool_vars[module_name_pfx];
    const configKeys = getConfigProductIds(config, false);
    return new Set(
      configKeys.filter((e) =>
        passRules(
          module_name_pfx,
          related_products_map[primaryId][e],
          config
        )
      ) || []
    );
  }

  function removeRuleBreakers(
    module_name_pfx,
    primaryId,
    config,
    compliers,
    useK
  ) {
    if (!primaryId) return config;
    if (!compliers) compliers = getCompliers(primaryId, config, module_name_pfx);
    const obj = {};
    const keys = Object.keys(config);
    for (var i = 0; i < keys.length; i++) {
      const k = keys[i];
      const v = config[k];
      if (typeof v === "object") {
        obj[k] = removeRuleBreakers(
          module_name_pfx,
          primaryId,
          v,
          compliers,
          true
        );
      }
      var valueToCheck = v;
      if (useK) valueToCheck = Number(k);
      if (compliers.has(valueToCheck)) obj[k] = v;
    }
    return obj;
  }

  //creates deep copy of an object
  function cloneDeep(obj) {
    const newObj = {};
    const keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
      const k = keys[i];
      const v = obj[k];
      if (typeof v === "object") {
        newObj[k] = cloneDeep(v);
      } else {
        newObj[k] = v;
      }
    }
    return newObj;
  }

  function getHypotheticalConfig(builtConfig, dataFilter, value, key) {
    if (!builtConfig) return null;
    const config = cloneDeep(builtConfig);
    if (key) {
      if (config[dataFilter]) config[dataFilter][key] = value;
      else {
        config[dataFilter] = {};
        config[dataFilter][key] = value;
      }
    } else config[dataFilter] = value;
    return config;
  }

  function hypotheticalConfigSatisfiesRules(
    module_name_pfx,
    primaryId,
    builtConfig,
    dataFilter,
    value,
    key
  ) {
    const config = getHypotheticalConfig(builtConfig, dataFilter, value, key);
    return allRulesSatisfied(primaryId, config, module_name_pfx);
  }

  //takes {"printer-model":94, "cabinet-stand-option":1, "additional-options":{98:2,100:1}}
  // and puts in the form d0=94&d1=1&c=98,100&cv=2,1
  function configToQueryParams(module_name_pfx) {
    const { key_filter_map } = cfgTool_vars[module_name_pfx];
    const config = configState[module_name_pfx];
    var dropdownIndex = 0;
    var checkboxIndex = 0;
    var dropdownQueries = [];
    var checkboxQueries = [];
    var checkboxCountQueries = [];
    const keys = Object.keys(config);
    for (var i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (key_filter_map.dropdowns.indexOf(key) !== -1) {
        dropdownQueries.push("d" + dropdownIndex + "=" + config[key]);
        dropdownIndex++;
      } else if (key_filter_map.checkboxes.indexOf(key) !== -1) {
        const cKeys = Object.keys(config[key]);
        for (var j = 0; j < cKeys.length; j++) {
          const k = cKeys[j];
          const v = config[key][k];
          if (checkboxQueries.length === 0) {
            checkboxQueries.push("c" + checkboxIndex + "=" + k);
            checkboxCountQueries.push("cv" + checkboxIndex + "=" + v);
          } else {
            checkboxQueries.push(k);
            checkboxCountQueries.push(v);
          }
        }
        checkboxIndex++;
      }
    }
    const queries = [
      dropdownQueries.join("&"),
      checkboxQueries.join(","),
      checkboxCountQueries.join(","),
    ];
    return queries.join("&");
  }

  // Initial configuration - attach on_change event to existing levers
  function cfgTool_init() {
    var module_names = Object.keys(cfgTool_vars);
    module_names.forEach((module_name) => {
      configState[module_name] = {};
      cfgTool_initCheckboxListeners(module_name);
      cfgTool_initDropdownListeners(module_name);

      // Reprocess logic
      cfgTool_reprocessLogic(module_name);
    });
  }

  cfgTool_init();

} catch (e) {
  console.println('ERROR - Config tool: ' + e);
}
`;

export default scripts;
